import { render, staticRenderFns } from "./CourseManagement.vue?vue&type=template&id=5788c004&scoped=true"
import script from "./CourseManagement.vue?vue&type=script&lang=js"
export * from "./CourseManagement.vue?vue&type=script&lang=js"
import style0 from "./CourseManagement.vue?vue&type=style&index=0&id=5788c004&prod&scoped=true&lang=css"
import style1 from "./CourseManagement.vue?vue&type=style&index=1&id=5788c004&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5788c004",
  null
  
)

export default component.exports